import moment from 'moment-timezone';

export class PricingCopilotMatrixOverview {
	public category: string;
	public usageTier: string;
	public currentMonth: string | Date;
	public currentDateLabel: string;
	public currentSumValue: number;
	public priorYearMonth: string | Date;
	public priorYearMonthDateLabel: string;
	public priorYearMonthSumValue: number;
	public estimatedSumValue: number;
	public percentChange: number;
	public utilityName: string;
	public sumValueDifference: number;
	public estimatedSumValueDifference: number;

	constructor(pricingCopilotMatrixOverview: PricingCopilotMatrixOverview) {
		Object.assign(this, pricingCopilotMatrixOverview);

		this.currentMonth = this.currentMonth ? new Date(moment(this.currentMonth).format('MMM DD, YYYY 00:00:00 a')) : this.currentMonth;
		this.priorYearMonth = this.priorYearMonth ? new Date(moment(this.priorYearMonth).format('MMM DD, YYYY 00:00:00 a')) : this.priorYearMonth;
	}
}
